'use client'

import { Menu } from 'antd'
import Link from 'next/link'
import React from 'react'
import type { Category } from '@/types/category';

export interface NavigationProps {
  domain: string;
  categories: Category[];
}

export default function Navigation({ domain, categories }: NavigationProps) {
  const items = categories.map(cat => ({
    label: <Link
      href={cat.route}
    >
      {cat.title}
    </Link>,
    key: cat.route,
  }));

  return (
    <div className="flex items-center justify-between h-12">
      <div className="text-lg font-semibold text-gray-900">
        {domain}
      </div>

      <Menu
        mode="horizontal"
        items={items}
        selectable={false}
        overflowedIndicator={null}
        theme="light"
        className="flex-1 justify-center border-0 shadow-none"
        style={{
          display: 'flex',
          justifyContent: 'center',
          boxShadow: 'none',
          borderBottom: 'none',
          fontSize: '1rem',
          fontWeight: 500
        }}
      />
    </div>
  );
}
